import React from 'react';
import { Tooltip } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import { NewsRanking, NewsSource } from './types';
import { readable } from './format';

const RankingHint: React.FC<{
  ranking?: NewsRanking;
  source: NewsSource;
  reason?: string;
  score?: number;
  id?: string;
  focusable?: boolean;
}> = ({ ranking, source, reason, score, id, focusable = true }) => {
  const ranked =
    typeof ranking?.importance_rank === 'number' && ranking.importance_rank > 0;
  if (!ranking && typeof score !== 'number') return null;
  const label = ranked
    ? `Importance #${ranking.importance_rank}`
    : source === 'corpus'
      ? 'Archive match'
      : 'Match relevance';
  const inheritance =
    ranked && ranking?.event_id != null
      ? 'Priority of the strongest linked event; articles supporting the same event share a rank.'
      : '';
  const reasons = ranking?.reasons?.length
    ? ranking.reasons
    : reason
      ? [reason]
      : [];
  const basis = ranking?.basis
    ? readable(ranking.basis)
    : ranked
      ? 'NewsRag event importance'
      : source === 'corpus'
        ? 'Legacy relevance ordering. Refresh NewsRag for impact-aware importance.'
        : 'Match to the instrument and selected evidence window.';
  return (
    <Tooltip
      title={
        <div>
          <strong>{basis}</strong>
          {ranked && <p>Rank among the selected event groups.</p>}
          {inheritance && <p>{inheritance}</p>}
          {reasons.length > 0 && (
            <ul className="market-explorer__ranking-reasons">
              {reasons.slice(0, 5).map((value, index) => (
                <li key={index}>{value}</li>
              ))}
            </ul>
          )}
        </div>
      }
    >
      <span
        id={id}
        className="market-explorer__ranking-hint"
        tabIndex={focusable ? 0 : undefined}
      >
        {label} <InfoCircleOutlined aria-hidden="true" />
        <span className="market-explorer__sr-only">
          . {basis}
          {ranked ? '. Rank among the selected event groups.' : ''}
          {inheritance ? `. ${inheritance}` : ''}
          {reasons.length ? `. ${reasons.join('. ')}` : ''}
        </span>
      </span>
    </Tooltip>
  );
};

export default RankingHint;
